<template>
  <div>
    <AppModal
      v-show="modalToggle"
      :message="message"
      :btnCase="2"
      @modalCancel="toggleModal"
      @modalCheck="modalCheck"
    />
    <div class='cusLayer full' id='app'>
      <div class='cusHd'> <!-- Header -->
        <div class='row borer_bottom'>
          <div class='col w100p'><h1 class='tit'>{{$t('searchAddress')}}</h1></div>
          <div class='col col3'>
            <button type='button' class='btnCloseModal' @click='onClickCloseBtn'>
              {{$t('close')}}
            </button>
          </div>
        </div>
      </div>
      <div class='cusCnt'>
        <div class='address_Top'>
          <p class='address_Tit'>{{$t('typeinAddress1')}}<br>{{$t('typeinAddress2')}}</p>
          <div class='address_Search'>
            <div class='address_Search_input'>
              <input v-model='keyword' type='text'
                :placeholder="$i18n.locale == 'ko' ? '예) 종로구 인사동길' : 'ex) Insa-dong, Jongno-gu'" class='input'
                @keyup.enter='onClickSearchBtn()'
                @input='onCheckInput'
                enterkeyhint="search"/>
              <button v-if='keyword.length > 0' type='button'
                class='btn del' @click='keyword = ""'/>
            </div>
            <div class='address_Search_Btn'>
              <button type='button' class='Btn'
                @click='onClickSearchBtn()'/>
            </div>
          </div>
          <!-- TODO 내위치 찾기 시 주석 해제 -->
          <SearchMyPosition />
        </div>
        <div v-if="appFlag">
          <div v-if="searchFlag" style="height: calc(100vh - 205px);">
            <div v-if='searchAddress.length > 0' class='address_List'>
              <div v-for='(juso, index) in searchAddress' :key='index' class='address_List_area'>
                <div class='list_Detail' @click.stop.prevent='chooseAddress(juso)'>
                  <p>{{juso.jibunAddr}}</p>
                  <span class='list_Detail_box'>도로명</span>
                  <span class='list_Detail_tit'>{{juso.roadAddr}}</span>
                </div>
              </div>
              <InfiniteLoading v-if='!lastPageFlag' @infinite='reqNextPage'/>
            </div>
            <div v-else class='noData address_Nodata'>
              <div class='in'>
                <span>해당 내역이 없습니다</span>
              </div>
            </div>
          </div>
          <div class="addressListWrap" v-if="addressList.length > 0">
            <div class="addressList" :class="{mainAddress: list.mainFlag}" v-for="(list, index) in addressList" :key="index" @click="setMainAddress(list)">
              <div class="addressIcon" :class="addressIcon[list.addressType ? list.addressType : 2]"></div>
              <h2 class="addressName">{{list.addressAlias ? list.addressAlias : list.jibunAddr}}
                <div class="checkIco" v-if="list.mainFlag"></div>
              </h2>
              <p>{{list.roadAddr + ' '}}{{list.detailAddress == undefined ? '' : list.detailAddress}}</p>
              <div class="addressBtns">
                <div @click.stop="addressDetailUpdate(index)">수정</div>
                <div @click.stop="openModal(index)" v-if="!list.mainFlag">삭제</div>
              </div>
            </div>
          </div>
          <div class='noData address_Nodata' v-else>
            <div class='in'><p>등록된 주소지가 없습니다.</p></div>
          </div>
        </div>
        <div v-else>
          <div v-if="searchFlag" style="height: calc(100vh - 205px);">
            <div v-if='searchAddress.length > 0' class='address_List'>
              <div v-for='(juso, index) in searchAddress' :key='index' class='address_List_area'>
                <div class='list_Detail' @click.stop.prevent='chooseAddress(juso)'>
                  <p>{{juso.jibunAddr}}</p>
                  <span class='list_Detail_box'>도로명</span>
                  <span class='list_Detail_tit'>{{juso.roadAddr}}</span>
                </div>
              </div>
              <InfiniteLoading v-if='!lastPageFlag' @infinite='reqNextPage'/>
            </div>
            <div v-else class='noData address_Nodata'/>
          </div>
          <!-- <div class='address_List latest'> -->
          <div v-else-if='recentAddress.length > 0' class='address_List latest'>
            <p class='address_Txt'>최근주소</p>
            <div v-for='(address, index) in recentAddressArr' :key='index' class='address_List_area'>
              <div class='list_Detail' @click='onClickRecentAddress(address)'>
                <p>{{address.jibunAddr}}</p>
                <span class='list_Detail_box'>도로명</span>
                <span class='list_Detail_tit' v-if="$i18n.locale == 'ko'">{{address.roadAddrPart1 ? address.roadAddrPart1 : address.roadAddr}}</span>
                <span class='list_Detail_tit' v-else>{{address.roadAddr}}</span>
              </div>
              <div class='list_Detail_btn'>
                <button type='button' class='btn_Close'
                  @click='deleteRecentAddress(index)'/>
              </div>
            </div>
          </div>
          <div v-else class='noData address_Nodata'>
              <div class='in'><p>최근 입력된 주소가 없습니다.</p></div>
          </div>
        </div>
      </div>
    </div>
    <!-- <AppSearchAddressPopUp
      :position.sync="position"
      :selectAddress.sync="selectAddress"
    /> -->
    <AddressDetail
      :selectAddress.sync="selectAddress"
      :position.sync="position"
      :addressLength="addressList.length"
      :homeActiveFlag.sync="homeActiveFlag"
      :updateType.sync="updateType"
      :recentAddress="recentAddress"
      @addresslist="addresslist"
      @moveGroup="moveGroup"
      @onClickCloseBtn="onClickCloseBtn"
    />
  </div>
</template>
<script lang="js">
import InfiniteLoading from 'vue-infinite-loading'
import AddressDetail from '@/components/App/AddressDetail.vue'
import SearchMyPosition from '@/components/Geolocation/SearchMyPosition.vue'
import AddressMixins from '@/utils/AddressMixins.js'

export default ({
  props: ['addressList', 'homeFlag'],
  components: { AddressDetail, InfiniteLoading, SearchMyPosition },
  mixins: [AddressMixins],
  methods: {
    // ㅡㅡㅡㅡㅡㅡㅡ etc ㅡㅡㅡㅡㅡㅡㅡ //
    moveGroup (addressEmdNm) {
      this.$emit('moveGroup', addressEmdNm)
    }
  }
})
</script>
<style scoped>
.input{
  display: flex;
  align-items: center;
}
.input p{
  opacity: .3;
}
</style>
